import React, { useState, useEffect, useContext, Fragment  } from "react";
import { api_domain } from "../config"
import Menu from "../components/navbar.js";
import "../styles/batch.css"
import { AuthContext } from "../components/AuthContext";

export function Batches() {
  const [batches, setBatches] = useState(null);
  const { basicHttpAuthString } = useContext(AuthContext);

  useEffect(() => {
    fetch(`${api_domain}/search/batch?order_by=id_desc&page=1&size=50`, {
      headers: {
        Authorization: `${basicHttpAuthString}`
      }
    })
      .then((response) => response.json())
      .then((data) => setBatches(data.items));
  }, [])

  return (
    <Fragment>
    <div className="container">
    <Menu/> 
        <div className="tools">
        <div className="titleMain">Batches</div>
        <div className="titleMinor">The 50 most recent batches of ads</div>
      {batches &&
        <div id="dataTableDiv">
        <table className="batchDataTable">
            <tbody>
            <tr>
              <th>Batch Id</th>
              <th>Batch Date</th>
              <th>Batch Type</th>
              <th>Batch Name</th>
            </tr>
            {batches.map((batch) => (
              <tr key={batch.id}>
                <td>
                  <a href={`/batch/${batch.id}`}>
                    {batch.id}
                  </a>
                </td>
                <td>
                  {new Date(batch.batch_date).toLocaleDateString("en-US")}
                </td>
                <td>
                  { batch.batch_type === 1 ? "crawl" 
                  : batch.batch_type === 2 ? "dataset" 
                  : batch.batch_type === 3 ? "Custom crawl" 
                  : batch.batch_type === 4 ? "OpenWPM crawl"
                  : "Unknown" }
                </td>
                <td>
                  {batch.human_name}
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>}
    </div>
    </div>
    </Fragment>
  );
}
